<template>
  <b-modal
      ref="modal"
      :title="id ? item.originalData.name : $t('New Element')"
      :visible="visible"
      hide-footer
      no-close-on-backdrop
      size="xl"
      style="min-height: 500px;"
      @change="$emit('update:visible', $event)"
      @hidden="onClose || onHidden()"
  >
    <element-form
        :project-id="projectId"
        :value="item"
    />
  </b-modal>
</template>

<script>
import ElementForm from "@/components/elements/ElementForm";
import itemMixin from "@/mixins/itemMixin";

export default {
  name: "ProjectElementsCreateView",
  components: {ElementForm},
  mixins: [itemMixin],
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    visible: {
      type: Boolean,
      default: true
    },
    onClose: {
      type: Function,
      default: null
    }
  },
  computed: {
    resourceName() {
      return `projects/${this.projectId}/elements`;
    },
  },
  beforeEnter: (to, from, next) => {
    if (this.$gate.allow('create', 'element')) {
      next();
    } else {
      this.forbiddenToast(this.$t('You are not allowed to create elements'));
      next({name: 'projects.elements', params: to.params})
    }
  },

  methods: {
    // onClose() {
    //     this.$emit('created')
    //     this.item = {};
    //     this.$router.push({
    //         name: 'projects.elements',
    //         props: {
    //             projectId: this.projectId
    //         }
    //     })
    // },

    onHidden() {
      this.$router.push({name: 'projects.elements', params: {projectId: this.projectId}})
    },
  }
}
</script>
